import React from 'react';
import styled from '@grebban/style-system-react';

const Strong = styled('strong')`
    font-weight: 700;
`;

interface BoldProps {
    children: React.ReactNode;
}

const Bold: React.FC<BoldProps> = ({ children }) => <Strong>{children}</Strong>;

export default Bold;
